import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import TransformIcon from '@material-ui/icons/Transform';
import _ from 'lodash';

import 'c3/c3.css';

import Loading from '../../Common/Loading';
import Dashboard from '../../Dashboard';
import { formatLocation, toJS } from '../../../utils/helper';
import {
  fetchRecentActivityRoutine,
  fetchReportRoutine,
} from '../../../redux/routines';

import styles from './styles';
import ListItemText from '@material-ui/core/ListItemText';
import OverallProgress from './OverallProgress';
import StageProgress from './StageProgress';
import TimeSeriesChart from './TimeSeriesChart';
import CumulativeAbsoluteToggle from './toggles/CumulativeAbsoluteToggle';
import Gravatar from '../../Common/Gravatar';


const generateProgress = (progress) => ({
  data: {
    columns: [
      ['data', progress],
    ],
    type: 'gauge',
  },
  gauge: {},
  color: {
    pattern: ['#FF0000', '#F97600', '#F6C600', '#60B044'], // the three color levels for the percentage values.
    threshold: {
      values: [30, 60, 90, 100],
    },
  },
  size: {
    height: 180,
  },
});


const getAction = (activity) => {
  const stage = activity.stage ? activity.stage : { name: 'Task Stage', relativeTo: 'origin' };
  switch (activity.action) {
    case 'job-started' :
      return 'Job Started';
    case 'task-started' :
    case 'task-stage-started' :
      return `${stage.name} Started - ${activity.task ? formatLocation(activity.task[stage.relativeTo]) : ''}`;
    case 'task-stage-completed' :
      return `${stage.name} Completed - ${activity.task ? formatLocation(activity.task[stage.relativeTo]) : ''}`;
    case 'task-item-acknowledged':
      return `${stage.name} - ${activity.item ? activity.item.type.name : 'Item'} acknowledged - ${activity.task ? formatLocation(activity.task[stage.relativeTo]) : ''}`;
    default:
      return 'Unknown Activity';
  }
};

class JobReport extends Component {
  state = {
    selectedStageIndex: 0,
    statistics: {},
    cumulative: true,
    processing: true,
  };

  componentWillMount() {
    console.log('this.match', this.props);
    const jobId = this.props.match.params.jobId;

    this.props.fetchReport(jobId);
  }

  handleSelectStage = (stage, idx) => {
    console.log('handleSelectStage', stage, idx);
    this.setState({
      selectedStageIndex: idx,
    });
  };

  renderActivityItem = (activity) => {
    return ([<ListItem
      secondaryTextLines={2}
    >
      <Gravatar email={activity.by ? activity.by.name : null}/>
      <ListItemText primary={activity.by ? activity.by.name : ''} secondary={<div>
        <div>{getAction(activity)}</div>
        <div>{moment(activity.at).format('lll')}</div>
      </div>}/>
    </ListItem>,
      <Divider/>]);
  };

  renderNoActivity = () => {
    return this.renderNoData('No Activity');
  };

  renderReport = (job, statistics, progress, timeSeries, tasks) => {
    const { activity } = this.props;
    const { cumulative } = timeSeries;

    const overall = _.values(progress.data.columns[0][1]).reduce((res, { complete, total }) => {
      return { complete: res.complete + complete, total: res.total + total }
    }, { complete: 0, total: 0 });
    console.log('over', overall);


    const overallProgress = {
      color: progress.color,
      data: _.assign({}, progress.data, {
        columns: [
          ['Overall', (overall.complete / overall.total) * 100],
        ],

      }),
      gauge: progress.gauge,
      size: progress.size,
    };

    // const stages = (job.profile || {}).stages || [];
    // console.log('stages', stages);

    // const jobProgressTimeSeriesChart = cumulative ? jobProgressTimeSeriesData.cumulative : jobProgressTimeSeriesData.absolute;

    console.log('progress', progress);
    console.log('overallProgress', overallProgress);

    /*
    //TODO readd to card header
    action={<CumulativeAbsoluteToggle
              value={this.state.cumulative ? 'cumulative' : 'absolute'}
              onChange={(value) => {
                console.log('val', value);
                this.setState({ cumulative: value === 'cumulative' });
              }}
            />}
    */

    return (<div>
      <div style={styles.summaryCharts}>
        <OverallProgress job={job} data={overallProgress}/>
        <StageProgress job={job} statistics={statistics}/>
      </div>
      <div style={styles.stats}>
        <Card style={styles.card2}>
          <CardHeader
            title="Job Progress"

          />

          <CardContent>
            <TimeSeriesChart job={job} timeSeries={timeSeries} tasks={tasks}/>
          </CardContent>
        </Card>
        {/*<div style={styles.card}>*/}
        {/*<Card>*/}
        {/*<CardTitle title={<div style={styles.title}><span style={{ display: 'inline-block' }}>Performance</span>*/}
        {/*<span style={{ display: 'flex', flexDirection: 'row' }}>*/}
        {/*<RaisedButton label="Best" onClick={() => { this.setState({ best: true }); }} labelColor="#FFFFFF"*/}
        {/*backgroundColor={this.state.gauge ? '#003F87' : '#3579DC'}/>*/}
        {/*<RaisedButton label="Worst" onClick={() => { this.setState({ best: false }); }}*/}
        {/*labelColor="#FFFFFF" backgroundColor={!this.state.gauge ? '#003F87' : '#3579DC'}/>*/}
        {/*</span></div>} titleColor="white" style={styles.greenCardTitle}/>*/}
        {/*<CardText>*/}
        {/*<List>*/}
        {/*<ListItem*/}
        {/*leftAvatar={<Avatar src={require('../../../../images/avatar1.png')}/>}*/}
        {/*primaryText="Ava Thornton"*/}
        {/*secondaryText={<div>*/}
        {/*<div>Pickup at US-MTV-1215, Desk 185</div>*/}
        {/*<div>{moment().format('lll')}</div>*/}
        {/*</div>}*/}
        {/*secondaryTextLines={2}*/}
        {/*/>*/}
        {/*<Divider inset/>*/}
        {/*<ListItem*/}
        {/*leftAvatar={<Avatar src={require('../../../../images/avatar2.png')}/>}*/}
        {/*primaryText="Bob Wilson"*/}
        {/*secondaryText={<div>*/}
        {/*<div>Inventorize at US-MTV-2398, Desk 281</div>*/}
        {/*<div>{moment().format('lll')}</div>*/}
        {/*</div>}*/}
        {/*secondaryTextLines={2}*/}
        {/*/>*/}
        {/*<Divider inset/>*/}
        {/*<ListItem*/}
        {/*leftAvatar={<Avatar src={require('../../../../images/avatar3.jpg')}/>}*/}
        {/*primaryText="Richard Knight"*/}
        {/*secondaryText={<div>*/}
        {/*<div>Dropoff at US-MTV-639, Desk 836</div>*/}
        {/*<div>{moment().format('lll')}</div>*/}
        {/*</div>}*/}
        {/*secondaryTextLines={2}*/}
        {/*/>*/}
        {/*</List>*/}
        {/*</CardText>*/}
        {/*</Card>*/}
        {/*</div>*/}
        {/*<Card style={styles.card}>*/}
          {/*<CardHeader title="Recent Activity"/>*/}
          {/*<CardContent>*/}
            {/*<List>*/}
              {/*{(activity || []).length > 0 ? (activity || []).map(this.renderActivityItem) : this.renderNoActivity()}*/}
              {/*/!*<Divider inset/>*!/*/}
            {/*</List>*/}
          {/*</CardContent>*/}
        {/*</Card>*/}
      </div>
    </div>);
  };

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <TransformIcon style={styles.noData}/>
      <div>No tasks are available</div>
    </div>);
  }

  render() {
    const { report } = this.props;

    if (!report || report.loading) {
      return (<Dashboard
        title="Job Report">
        <Loading/>
      </Dashboard>);
    }

    console.log('rep', report);
    const { data: { job, statistics, timeseries, tasks } } = report;

    const progress = generateProgress(statistics);

    // console.log('job', job);
    return (
      <Dashboard
        title={`Job Report - ${job.customer ? job.customer.name : ''}${job.description ? ` - ${job.description}` : ''}`}>
        {this.renderReport(job, statistics, progress, timeseries, tasks)}
      </Dashboard>
    );

  }
}

JobReport.propTypes = {
  match: PropTypes.object.isRequired,
  fetchReport: PropTypes.func.isRequired,
  // fetchTasks: PropTypes.func.isRequired,
  // fetchEmployees: PropTypes.func.isRequired,
  fetchRecentActivity: PropTypes.func.isRequired,
  report: PropTypes.object,

  // job: PropTypes.object,
  // tasks: PropTypes.object,
  activity: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    // fetchJob: fetchJobRoutine.trigger,
    // fetchTasks: (jobId) => fetchTasksRoutine.trigger({ jobId }),
    // fetchEmployees: fetchEmployeesRoutine.trigger,
    fetchRecentActivity: fetchRecentActivityRoutine.trigger,
    fetchReport: (jobId) => fetchReportRoutine.trigger({
      report: 'jobreport',
      jobId,
    }),
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    report: toJS(state.getIn(['reports', 'jobreport'])),
    // job,
    // tasks: toJS(state.getIn(['tasks', 'tasks'])), // TODO remove use job stats instead
    // employees: toJS(state.getIn(['employees', 'employees'])),
    activity: toJS(state.getIn(['activity', 'recent'])), //.sort((a, b) => sortStrings(b.at, a.at)), //TODO reinstate
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(JobReport);



// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/index.js